import styled from 'styled-components';
import { WarningBadge } from '../WarningBadge';

export const Wrapper = styled.div`
  min-width: 750px;
  width: 750px;
  border-radius: 24px;
  background-color: #edf0f5;
  padding: 16px;
  overflow: hidden;
`;

export const Body = styled.div`
  width: 100%;
  border-radius: 12px;
  background-color: #fff;
  padding: 40px;

  .badge {
    margin: 10px 0;
    width: 380px;
  }
`;

export const SelectAllStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 26px;
  margin-bottom: 10px;

  p {
    color: #2b313d;
    font-size: 16px;
    font-weight: 500;
  }

  .select-all {
    color: #2b313d;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
  justify-content: flex-end;

  button {
    width: 25%;
  }
`;

export const Title = styled.div`
  color: #5c5d61;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  padding-bottom: 12px;
  border-bottom: 2px solid #cdd4df;
`;

export const Funds = styled.div`
  border: 1px solid #f1f3f5;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 16px;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 8px;
    background-color: #f8f9fa;
    .select-all {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #868e96;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
    }
    p {
      color: #868e96;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
    }
  }
  .item {
    padding: 22px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    color: #000;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    border-bottom: 1px solid #f1f3f5;
  }
`;

export const FundName = styled.div`
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 8px;
  background: #fff;
  color: #5c5d61;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
`;

export const StyledWarningBadge = styled(WarningBadge)`
  width: 100%;
  display: flex;
  align-items: flex-start;
  background: #ffe0e0;
`;
